// Frontend Configuration
// Edit these values based on your environment

const config = {
  development: {
    apiUrl: "https://api.melona.com.et/api/v1", // Using production API for development
  },
  production: {
    apiUrl: "https://api.melona.com.et/api/v1", // Production API URL
  },
};

// Auto-detect environment
const env = process.env.NODE_ENV || "development";
const currentConfig = config[env];

export default currentConfig;
